/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router'
import AssignaTagsView from '@/views/AssignaTagsView.vue'
//import AssignaTagsView from '@/views/AboutView'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/tags'
  },
  {
    path: '/tags',
    name: 'tags',
    //component: () => import(/* webpackChunkName: "TagsView" */ '@/views/AssignaTagsView.vue')
    component: AssignaTagsView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
